<template>
  <div v-if="showReviewSettings || showManagerNotify" class="wrapper no-label-css">
    <template v-if="showReviewSettings">
      <h3>Review Settings</h3>
      <div class="box">
        <b-form-group label="Select appropriate admin to approve your order:">
          <b-select v-model="checkoutInfo.reviewer" :options="approverOptions">
          </b-select>
        </b-form-group>
      </div>
    </template>
    <template v-if="showManagerNotify">
      <h3>Manager Notification</h3>
      <div class="box">
        <b-form-checkbox v-model="checkoutInfo.managerCheckbox">Ordering of these business cards are approved by my manager</b-form-checkbox>
        <b-form-group label="Manager email:">
          <b-form-input v-model="checkoutInfo.reviewer"/>
        </b-form-group>
      </div>
    </template>
  </div>
</template>

<style scoped lang="scss">
@import '~scss/colors';

.wrapper {
  margin-top:15px;
}

.box {
  background-color: #ededed;
  border:$gray-1 1px solid;
  padding: 1em 2em 2em 2em;

  &div {
    max-width: 450px;
  }
}
</style>

<script>
import {mapGetters, mapActions} from 'vuex';
export default {
  data() {
    return {preApproved: false}
  },
  computed: {
    ...mapGetters(['approvalSettings', 'approvers', 'checkoutInfo']),
    showReviewSettings() {
      let {approvalMode, approverDesignation} = this.approvalSettings;
      if (!approvalMode) return; // approval not set up
      if (this.checkoutInfo.skip_review) return; // approval skipped
      return approverDesignation === 'chooseOnCheckout';
    },
    showManagerNotify() {
      // We show this whether or not approval is enabled.
      return this.approvalSettings.requireNotifyEmail;
    },
    approverOptions() {
      return this.approvers.map(({name, email}) => ({text: `${name} (${email})`, value: email}));
    }
  },
  mounted() {
    this.loadApprovers();
  },
  methods: mapActions(['loadApprovers']),
}
</script>



// WEBPACK FOOTER //
// src/components/pages/checkout/CheckoutReviewSettings.vue